import store from '@store/index'

function AgencyGuard(to, from, next) {
  const user = store.getters['auth/user']
  if (!user || !user.agency) next({ name: 'login' })
  else if (user.role === 'Admin') next('/')
  else if (['AgencyUser', 'WebsiteUser'].includes(user.role)) {
    const whitelists = [
      'agency.profile',
      'agency.websites.index',
      'agency.websites.form.create',
      'agency.websites.form.edit',
      'agency.websites.menu.create',
      'agency.websites.menu.edit',
      'agency.websites.redirect.create',
      'agency.websites.redirect.edit',
      'agency.websites.integration.create',
      'agency.websites.gateway.create',
      'agency.podcast.edit',
      'agency.blogs.create',
      'agency.blogs.edit',
      'agency.pages.index',
      'agency.pages.create',
      'agency.pages.aicreate',
      'agency.pages.design',
      'agency.pages.sandbox_design',
      'agency.blogs.design',
      'agency.blogs.sandbox_design',
      'agency.cards.create',
      'agency.cards.edit',
      'agency.cards.preview',
      'agency.card.transfer',
    ]
    if (user.role === 'AgencyUser' && user.can_create_landing) {
      whitelists.push('agency.websites.create')
      whitelists.push('agency.websites.share')
    }
    if (whitelists.includes(to.name)) next()
    else next('/')
  } else if (
    !user.agency.subscribed && !user.agency.free_fee && !user.agency.free_register &&
    (!user.hasCourses || (user.agency.stripe_status !== 'canceled' && user.agency.reseller_status !== 'canceled'))
  ) {
    if (to.name !== 'agency.subscription') next({ name: 'agency.subscription' })
    else next()
  } else next()
}

export default AgencyGuard